import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AssignmentService } from '@examdojo/assignment';
import { SyllabusQuery } from '@examdojo/category/v2';
import { ChallengeActivityQuery } from '@examdojo/challenge';
import { ErrorHandlerService } from '@examdojo/core/error-handling';
import { distinctUntilChanged, EMPTY, filter, map, merge, pairwise, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FetchAssignmentsOnSyllabusChangeEffectService {
  constructor(
    private readonly assignmentService: AssignmentService,
    private readonly syllabusQuery: SyllabusQuery,
    private readonly challengeActivityQuery: ChallengeActivityQuery,
    private readonly errorHandlerService: ErrorHandlerService,
  ) {
    merge(this.fetchAssignmentsOnSyllabusChange(), this.fetchAssignmentsOnChallengeComplete())
      .pipe(takeUntilDestroyed())
      .subscribe();
  }

  private fetchAssignmentsOnSyllabusChange() {
    return this.syllabusQuery.activeIdAndCourseLevel$.pipe(
      switchMap(() => this.fetchAssignments({ resetStore: true })),
    );
  }

  private fetchAssignmentsOnChallengeComplete() {
    return this.challengeActivityQuery.inProgressChallengeActivityId$.pipe(
      filter(Boolean),
      switchMap((activityId) =>
        this.challengeActivityQuery.selectEntity(activityId).pipe(
          map((activity) => activity?.status),
          filter(Boolean),
          distinctUntilChanged(),
          pairwise(),
          filter(([prevStatus, currStatus]) => prevStatus !== 'COMPLETED' && currStatus === 'COMPLETED'),
        ),
      ),
      switchMap(() => this.fetchAssignments()),
    );
  }

  private fetchAssignments(options?: { resetStore?: boolean }) {
    return this.assignmentService
      .fetchAssignmentsWithSections(options)
      .pipe(this.errorHandlerService.catchHttpErrors(() => EMPTY));
  }
}
